export default [
  { label: 'Domain', value: 'domain'},
  { label: 'Flow', value: 'xflow'},
  { label: 'Functions', value: 'fngroup'},
];
